import FlashcardsAPI from "@/services/api/flashcards"
import type { Params } from "@/services/api/flashcards/get-all"
import { useQuery } from "@tanstack/react-query"

const useGetUserFlashcards = (params: Params) => {
  const query = useQuery({
    queryKey: ["get-flashcards", params],
    queryFn: async () => FlashcardsAPI.getAll(params),
  })

  return query
}

export default useGetUserFlashcards
